/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "15.5.2";
